import * as catalogos from './catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB': 'Salvar mudanças..',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG': 'Perguntas',
      'TITULO_TAB_TRAD': 'Tradução',
      'TITULO_TAB_PREV': 'Preview',
      'TAB_PREGUNTAS':{
        'CLA':'Chave:',
        'BTN_CONFIG_PLA': 'Configuração do modelo',
        'SLI_VER_US_EMPRE': 'Ver como um utilizador empresarial',
        'ETI_INSTNES': 'Pode carregar uma lista de perguntas contidas num modelo, seguindo estes passos:',
        'ETI_INST1': 'Descarregar o modelo',
        'ETI_INST2': 'Preencher o modelo com as perguntas de acordo com o formato',
        'ETI_INST3': 'Carregar o modelo com as perguntas',
        'ETI_INST_NOT': 'Nota: pode carregar uma lista de perguntas de uma forma geral ou dentro de cada secção disponível',
        'ETI_SECCI_NOT_GRU': 'Esta secção não tem grupo',
        'INST_AGRE_GRUP': 'Adicione um grupo de perguntas com o seguinte botão',
        'BTN_AGRE_GRUP': 'Adicionar um grupo',
        'INST2_AGRE_GRUP': 'Pode acrescentar perguntas a este grupo mais tarde',
        'ETI_DETEC_CAMB_PLAN': 'Foram detectadas alterações no modelo original',
        'BTN_GUAR_CAMB': 'Guardar alterações',
        'BTN_GUAR_CAMB_NEW_PLAN': 'Salvar como novo modelo',
        'MAT_DESC_PLAN': 'Descarregar modelo',
        'ETI_LIS_GRUP': 'Lista de grupo',
        'MAT_CHIP_PRE_EXTR_SI': 'Perguntas extra disponíveis: ',
        'MAT_CHIP_PRE_EXTR_NO': 'Já não se podem acrescentar mais perguntas',
        'MAT_CHIP_PRE_EXTR_ILIM': 'Perguntas extra ilimitadas',
        'ETI_INST_COLO_CUR': 'Coloque o cursor sobre qualquer grupo para ver as acções disponíveis',
        'MAT_EDIT_NOMB_SECC': 'Editar o nome do grupo',
        'MAT_DELET_SECC': 'Remover este grupo',
        'MAT_AGRE_SECC_ARRI': 'Adicionar um grupo acima',
        'ETI_SECC_SIN_PREG':'Este grupo não tem perguntas',
        'ETI_SECC_INST_COLO_CUR': 'Coloque o cursor sobre uma pergunta para ver as acções disponíveis',
        'ETI_PREG_OPCIO_EDITA': 'Pergunta editável opcional',
        'ETI_PREG_OPCIO_NO_EDITA': 'Pergunta facultativa não editável',
        'ETI_PREG_OPCIO_OPCIO_OBLI_EDITA': 'Pergunta editável obrigatória',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA': 'Pergunta obrigatória não editável',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Resposta obrigatória às perguntas',
        'MAT_FALT_OPC_RESP': 'Faltam opções de resposta',
        'ETI_FALT_OPC_RESP': 'Perguntas em falta de opções de resposta',
        'MAT_NO_GUAR_CATA': 'Ainda não guardado no catálogo',
        'ETI_PREG_NO_GUAR_CATA': 'Pergunta ainda não guardada no catálogo',
        'MAT_CHIP_TIP': 'tipo',
        'MAT_TOOL_DETA_PREG': 'Detalhe da pergunta',
        'BTN_EDIT_PREG': 'Veja detalhes',
        'MAT_TOOL_MOVE_PREG': 'Mover esta pergunta',
        'BTN_EDIT_ES_PREG': 'Editar esta pergunta',
        'BTN_DELE_ES_PREG': 'Apagar esta pergunta',
        'MAT_TOOL_AGRE_PREG_ARRI': 'Adicionar pergunta acima',
        'MAT_TOOL_AGRE_PREG_ABAJ': 'Adicionar pergunta abaixo',
        'MAT_LABE_SELE_VERSI_PREG': 'Seleccione uma versão da pergunta',
        'MAT_LABE_TEX_PREG': 'Texto da pergunta',
        'MAT_LABE_TEX_PREG_KEY':'Chave de pergunta especial',
        'ETI_CUE_SIG_ACC_PREG': 'Conte com as seguintes acções para esta questão',
        'MAT_CARD_MAES': 'Catálogo principal',
        'ETI_DETEC_CAMB_TEX_PREG': 'Foram detectadas alterações no texto da pergunta',
        'MAT_TOOL_YET_NO_GUA_CAT': 'Ainda não guardado no catálogo',
        'ETI_ESTA_PREG_NO_GUAR_CATA': 'Esta pergunta não está guardada no catálogo',
        'ETI_GUAR_PREG': 'Salvar pergunta',
        'ETI_GUAR_CAMB': 'Guardar alterações',
        'MAT_SLIDE_PREG_EDIT': 'Pergunta editável',
        'MAT_SLIDE_PREG_DELET': 'Pergunta removível',
        'MAT_SLIDE_PREG_REQUI': 'Resposta obrigatória',
        'ETI_AGRE_PREG': 'Acrescentar uma pergunta',
        'ETI_GRUP_PREG': 'Grupo de perguntas',
        'ETI_SECC_ESP':'Seção Especial',
        'ETI_KEY_NO_EMPL':'chave da secção especial não utilizada',
        'ETI_FALT_KEY_SEC_ESP':'*Seta a chave da seção especial',
        'ETI_CLA_GRU_LIS': 'Palavra-chave:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG': 'Move question',
          'ETI_INTS_SELEC_SECC_MOVE': 'Seleccione o grupo para o qual pretende mover a pergunta',
          'ETI_NOT_PREG_MOVE1': 'NOTA:',
          'ETI_NOT_PREG_MOVE2': 'A questão será deslocada para o fim do grupo seleccionado',
          'BTN_CANCELAR': 'Cancelar',
          'ETI_CONFI_PLAN': 'Configuração do modelo',
          'ETI_DATOS_PLAN': 'Modelos de dados:',
          'ETI_NOMB': 'Nome:',
          'ETI_SECC': 'Grupos:',
          'ETI_PREG': 'Perguntas:',
          'ETI_NOT_CONF_CONT_SECC': 'NOTA: A configuração destes controlos aplica-se a todos os grupos e questões no modelo em modo de visualização como utilizador de tipo empresarial',
          'ETI_PERMI_SECC': 'Licenças de grupo',
          'ETI_AGRE_SECC_NEW': 'Adicionar novos grupos',
          'ETI_MOVE_SECC': 'Mover grupos',
          'ETI_EDIT_TITU': 'Editar título',
          'ETI_DELET_SECC': 'Eliminar grupos',
          'ETI_NOMB_OBL_GRUP_NEW':'Nomes obrigatórios em novos grupos',
          'ETI_ENABLE_SEC_ESP': 'Ativar perguntas/seções especiais',
          'ETI_PERMIS_PREG': 'Permissão para fazer perguntas de cada grupo:',
          'ETI_AGRE_PREG_NEW': 'Acrescentar novas perguntas',
          'ETI_AGRE_PREG_CATAL': 'Adicionar perguntas do catálogo',
          'ETI_MOVE_PREGS': 'Move questions',
          'ETI_EDIT_PREG': 'Editar perguntas',
          'ETI_DELET_PREG': 'Apagar perguntas',
          'ETI_PREG_NEW_MAX': 'Novas questões máximas',
          'ETI_MAX_PREG_NEW': 'Máximo de novas perguntas',
          'ETI_ENABLE_AUDIOS': 'Habilitar faixas de áudio',
          'ETI_DEMOGRAF': 'Demográficos',
          'ETI_ABIER': 'Aberto',
          'ETI_PRAC4ALL': 'Practices 4All',
          'ETI_ADICIO': 'Adicional',
          'BTN_SAL': 'Sair',
          'ETI_INST_AGRE_PREG_CAT': 'Adicionar pergunta de catálogo',
          'ETI_BUSC_SELECC_PREG_PLAN': 'Neste ecrã pode pesquisar e seleccionar perguntas a acrescentar ao modelo',
          'ETI_VER_LIS_PREG_SELEC_3_PEST': 'Pode ver a lista de perguntas seleccionadas no terceiro separador desta janela',
          'TITULO_TAB_LIS_PREG':'Lista de perguntas',
          'TITULO_TAB_BUSC_PREG':'Pergunta de pesquisa',
          'TITULO_TAB_PREG_SELEC':'Perguntas selecionadas',
          'PASO_1':'Paso 1',
          'PASO_2':'Paso 2',
          'ETI_SELEC_PREG_LIS_CAT': 'Seleccione a pergunta da lista do catálogo',
          'ETI_SELEC_PREG': 'Seleccione uma pergunta',
          'ETI_YA_SELEC_NUM_MAX_PREG': 'Já seleccionou o número máximo de perguntas adicionais permitidas no modelo',
          'ETI_PREG_MS_UNA_VERS': 'Esta pergunta tem mais do que uma versão, seleccione a que pretende ver',
          'ETI_SELEC_VERS': 'Seleccione uma versão',
          'ETI_PREG_SELECCIONDA': 'Pergunta seleccionada:',
          'ETI_AGRE_PREG': 'Adicionar pergunta',
          'ETI_OK_AGRE_PREG_LIST':'<b>A pergunta foi adicionada à lista de perguntas</b>, pode escolher e adicionar mais perguntas para adicionar ao modelo',
          'ETI_OK_AGRE_PREG_LIST2': 'Pode também ver a lista de perguntas seleccionadas no terceiro separador desta janela',
          'ETI_ESCR_TEXT_BUSC': 'Introduza o texto da pergunta que deseja pesquisar',
          'ETI_BUSC_PREG_COINC': 'Procura de perguntas correspondentes',
          'ETI_NO_ENCO_PREG': 'Não foram encontradas perguntas com o texto introduzido, tente um texto diferente',
          'ETI_RESUL_BUSC': 'Resultados da pesquisa',
          'BTN_ELEG': 'Escolher',
          'ETI_REGRE_RESUL': 'Regresso aos resultados',
          'ETI_PREG_SELECC_MOMEN': 'Lista de perguntas seleccionadas até ao momento',
          'MAT_TOOL_ELEG_VERSI': 'Escolha outra versão',
          'MAT_TOOL_ELI_VERSI':'Remover versão',
          'BTN_REGRES': 'Regresso',
          'BTN_ELIG_VERSI': 'Escolher versão',
          'MAT_TOOL_QUITA_LIS': 'Remover da lista',

          'BY_TEXT': 'Por texto de pergunta',
          'BY_KEYWORDS': 'Por palavras-chave',
          'QUESTION_TEXT': 'Texto da pergunta',
          'QUESTION_KEYWORDS': 'Palavras-chave',
          'QUESTION_HINT': 'As palavras-chave devem começar com o caractere <b> # </b> e ser separadas por vírgulas'
        },
        'DETALLE':{
          'ETI_DETALL_PREG': 'Detalhe da pergunta',
          'ETI_LAB_TEX_PREG': 'Texto da pergunta',
          'PLACE_HOL_TEX_PREG': 'Texto da pergunta',
          'MAT_TOOL_EDIT_PREG': 'Editar esta pergunta',
          'MAT_CARD_OPC_RESP': 'Opções de resposta',
          'MAT_TOOL_EDIT_RESP': 'Editar esta resposta',
          'MAT_TOOL_DELET_RESP': 'Apagar esta resposta',
          'ETI_AGRE_OPCI_RESP': 'Adicionar uma opção de resposta',
          'ETI_SELEC_VERSI_PREG': 'Seleccione uma versão da pergunta',
          'ETI_CUENT_SIG_ACC_PREG': 'Conte com as seguintes acções para esta questão',
          'ETI_DETEC_CAMB_TEXMAES': 'Catálogo principal',
          'ETI_CATA_MAES': 'Catálogo principal',
          'ETI_DETEC_CAMB_TEX_PREG': 'Foram detectadas alterações no texto da pergunta',
          'ETI_DETEC_CAMB_TEX_RESP': 'Alterações nas opções de resposta detectadas',
          'ETI_PREG_NO_GUAR_CATA': 'Esta pergunta não está guardada no catálogo',
          'ETI_GUAR_PREG': 'Salvar pergunta',
          'ETI_GUAR_CAMB': 'Guardar alterações',
          'ETI_BORR_PREGUN':'Borrar pergunta',
          'ETI_DELET_PREG': 'Eliminar pergunta',
          'MAT_CARD_PLAN': 'Template',
          'MAT_SLIDE_PREG_EDIT': 'Pergunta editável',
          'MAT_SLIDE_PREG_DELET': 'Pergunta removível',
          'MAT_SLIDE_PREG_REQUI': 'Resposta obrigatória',
          'BTN_REGRES': 'Regresso',
          'ETI_NEW_PREG': 'Nova pergunta',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE': 'Digite o texto e seleccione o tipo de resposta para a nova pergunta',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP': 'Introduzir texto e acrescentar opções de resposta para a nova pergunta',
          'ETI_TIP_PREG': 'Tipo de pergunta',
          'ETI_TIP_RESP': 'Tipo de resposta',
          'ETI_TIP_FORM':'Formato da pergunta',
          'ETI_PREG_ESP_FLD': 'Chave de pergunta especial',
          'ETI_PREG_ESP_HNT': 'Digite a chave para a pergunta especial',
          'BTN_CANCELAR': 'Cancelar',
          'BTN_CONTINU': 'Continuar',
          'ETI_NEW_PRAC_4ALL': 'New 4All practice',
          'ETI_INST_NAME_DESC_4ALL': 'Introduza o nome e a descrição para a nova prática 4All',
          'ETI_LABE_NAME': 'Nome de prática',
          'ETI_LABE_DESC': 'Descrição da prática',
          'ETI_CLAVE_DEMOGR': 'Escreva uma ou mais palavras-chave que identifiquem a questão, começando pelo carácter ',
          'ETI_CLAVE_DEMOGR1': 'e separados por vírgulas',
          'ETI_CLAVE_DEMOGR2': 'NOTA: Palavras-chave só serão armazenadas se você salvar esta questão no catálogo ao fechar esta janela',
          'ETI_PALA_CLAVE_DEMOGR': 'Palavras-chave',
          'ETI_SELE_TIPO_DEMOGR': 'Seleccione o tipo de demografia que corresponde à nova pergunta',

          'MAT_TOOL_CONFIG_RESP':'Configurar esta resposta',
          'MAT_SLIDE_RESP_EDIT':'Resposta editável',
          'MAT_SLIDE_RESP_DELET':'Resposta removível',
          'MAT_SLIDE_RESP_TIPO_OTRO':'Digite "Outro"',
          'MAT_TOOL_NEWVERS_PREG':'Salvar como nova versão',
          'NOTA_PREG_MOD': 'NOTA: O texto desta questão foi modificado, você pode salvá-lo como uma nova versão se desejar',
          'RESPUESTA_TIPO_OTRO':' - responda digite "Outro"',

          'TIPO_DEMOGRAFICO':'Tipo demográfico',
          'SIN_TIPO_DEMOGRAFICO':'Nenhum tipo demográfico selecionado para esta pergunta'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP': 'New template',
          'TEXT_MOD_GUA_CAM_TEMP': 'Type the name for the new template',
          'BTN_CAN_MOD_GUA_CAM_TEMP': 'Cancel',
          'BTN_AGRE_MOD_GUA_CAM_TEMP': 'Add',
          'RETUR_MOD_GUA_CAM_TEMP': 'You have not entered a text for the name',
          'SUCC_TEXT_MOD_GUA_PLAN': 'The new template was saved correctly',
          'TITU_MOD_GUA_CAM_TEMP2': 'Do you want to save the changes made to the original template? WARNING: The next time a product is assigned with this template, all the changes made so far will be included',
          'BTN_CONTI_MOD_GUA_CAM_TEMP': 'Continue',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG': 'Changes to the original template were saved correctly',
          'MENS_1': 'What kind of question do you want to add to the section?',
          'MENS_2': 'You have two options',
          'BTN_NEW': 'New',
          'BTN_D_CATA': 'From catalogue',
          'TITU_MOD_CARG_LIS_COLAB_P1': 'Este ficheiro contém',
          'TITU_MOD_CARG_LIS_COLAB_P2': 'secções e um total de',
          'TITU_MOD_CARG_LIS_COLAB_P3': 'perguntas.ATENÇÃO: Se continuar a carregar este ficheiro, as perguntas e grupos que tem actualmente serão substituídos',
          'TITU_TEX_MOD_CARG_LIS_COLAB': 'Tem duas opções',
          'BTN_AGRE_PREGU': 'Acrescentar as perguntas',
          'BTN_CANC_PREGU': 'Questões de descarte',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB': 'As perguntas foram acrescentadas correctamente',
          'TEXT_MOD_NOT_CARG_LIS_COLAB': 'As perguntas foram descartadas',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB': 'O ficheiro seleccionado tem erros e não pode ser carregado. Verifique novamente se todas as filas estão colocadas na ordem correcta e tente novamente',
          'BTN_OK': 'OK',
          'TITU_MOD_NEW_SECC': 'Nova secção',
          'TEXT_MOD_NEW_SECC': 'Introduza o nome para a nova secção',
          'TEXT_SUCC_PREG_AGRE': 'A pergunta foi acrescentada correctamente',
          'TITU_MOD_EDI_SECC': 'Modificar o nome da secção',
          'TEXT_SUCC_MODIF_SECC': 'Nome da secção alterado correctamente',
          'TEXT_SUCC_MODIF_GRU':'O nome do grupo foi modificado',
          'TITU_MOD_DELE_SECC1': 'Tem a certeza que quer apagar esta secção?',
          'BTN_SI': 'Sim',
          'BTN_NO': 'Não',
          'TITU_MOD_DELE_SECC2': 'Esta secção contém uma ou mais perguntas, o que pretende fazer com estas perguntas',
          'BTN_DELE_PRE': 'Apagar as perguntas',
          'BTN_CAN_TRAN': 'Transfira-os para a secção anterior',
          'TEX_SUCC_DELE_PREG': 'A secção foi eliminada correctamente',
          'TITU_AGRE_NEW_PREG': 'Nova pergunta',
          'TEXT_AGRE_NEW_PREG': 'Introduza o texto para a nova pergunta',
          'TITU_EDIT_PREG_MOD_PREG': 'Modificar pergunta',
          'TITU_EDIT_PREG_MOD_PRACT': 'Modificar a prática',
          'TITU_EDIT_PREG_MOD_DESCRI': 'Modificar descrição',
          'TEXT_MOD_PREG_SUCC': 'A pergunta foi modificada correctamente',
          'TITU_2_OPCIO': 'Tem duas opções para salvar esta modificação',
          'BTN_CONF_ACT':'Pergunta de atualização',
          'BTN_CANC_NEW': 'Como nova pergunta',
          'BTN_CONF_ACT_VERSION':'Atualize esta versão',
          'BTN_CANC_NEW_VERSION':'Como nova versão',
          'TEX_CONFIR_MSG1': 'A pergunta foi modificada correctamente',
          'TEX_CONFIR_MSG2': 'Prática modificada correctamente',
          'TEX_CONFIR_MSG3': 'A descrição foi modificada correctamente',
          'TITU_DELE_PREG': 'Tem a certeza de querer apagar esta pergunta?',
          'TEXT_SUCC_PREG': 'A pergunta foi eliminada correctamente',
          'TITU_MOD_DELE_SECC_TEMPLA': 'Tem a certeza que quer apagar esta secção?',
          'TITU_MOD_DELE_SECC_TEMPLA2': 'Esta secção contém uma ou mais perguntas, o que pretende fazer com estas perguntas',
          'TEX_SUCC_GUAR_PREG_': 'A questão foi correctamente guardada',
          'TITU_MOD_DELE_PREG_MG': 'Tem a certeza de que quer eliminar a pergunta do catálogo? AVISO: Esta acção não pode ser invertida e a pergunta deixará de estar disponível nos modelos que actualmente a contêm',
          'TEX_CONFIR_MSG4_DELE': 'A pergunta foi retirada do catálogo correctamente',
          'TEX_GUAR_TRADU_SUCC': 'A tradução foi guardada correctamente',
          'TEX_MOVE_PREG_SECC': 'Pergunta transferida para outra secção',
          'TEX_SUCC__PRAC_4ALL': 'A prática foi acrescentada correctamente',
          'MOD_MOD_AGRE_PREG': 'A pergunta foi acrescentada correctamente à lista',
          'MOD_MOD__MODIF_VERSI_PREG': 'A versão da pergunta foi alterada correctamente',
          'MOD_MOD__QUIT_PREG_LIST': 'A versão da pergunta foi alterada correctamente',
          'TITU_NUE_OPC_RESP': 'Nova opção de resposta',
          'TEXT_NUE_OPC_RESP': 'Introduzir texto para nova opção',
          'TEXT_NO_TEXT_PREG': 'Não introduziu um texto para a pergunta',
          'TEXT_AGRE_OPC_RESP': 'Opção de resposta acrescentada correctamente',
          'MOD_EDIT_RESP': 'Modificar a opção de resposta',
          'MOD_EDIT_MODIF_OPC_RESP': 'A opção de resposta foi modificada correctamente',
          'MOD_COMFIR_DELE_OPC_RESP': 'Tem a certeza de que quer apagar esta opção de resposta?',
          'MOD_SUCC_DELE_OPC_RESP': 'A opção de resposta foi correctamente eliminada',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP': 'Não pode continuar sem acrescentar opções de resposta à pergunta',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP': 'Não pode continuar sem ter escrito primeiro o texto da pergunta',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP': 'Não pode continuar sem ter escolhido o tipo de pergunta',
          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Antes de adicionar a nova pergunta, deseja que ela seja salva no catálogo? Ou você quer apenas ter nesta pesquisa?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'Ao salvá-lo no catálogo, você pode torná-lo disponível para outras pesquisas, se desejar.',
          'BOT_DONDE_GUARDAR_1': 'Salve no catálogo',
          'BOT_DONDE_GUARDAR_2': 'Salve-o apenas para esta pesquisa',
          'MOD_SIN_TAGS': 'Você ainda não inseriu pelo menos uma palavra-chave para a pergunta',
          'MOD_SIN_OPC_RESP': 'Você ainda não inseriu pelo menos duas opções de resposta para a pergunta',
          'MOD_SIN_TIPO_DEMO': 'Você ainda não selecionou o tipo demográfico para esta pergunta',
          'MOD_SIN_CLA_ESPE': 'Você ainda não adicionou a chave para a pergunta especial',
          'MOD_SIN_TIPO_RESP': 'Você não pode continuar sem selecionar o tipo de resposta para a pergunta',
          'MOD_RESP_DELOK': 'Opção de resposta excluída com sucesso',
          'MOD_RESP_DELCATOK': 'A pergunta foi removida do catálogo com sucesso',
          'MOD_RESP_ADDTAGOK': 'Palavra-chave adicionada à pergunta corretamente',
          'MOD_RESP_ADDTAGERR': 'A palavra-chave não começou com o caractere #',
          'MOD_RESP_DELTAGOK': 'A palavra-chave foi removida da pergunta corretamente',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'Ao salvar as alterações nesta pergunta do catálogo, as modificações feitas serão salvas como novas versões dos textos da pergunta e opções de resposta, se aplicável.\n\nVocê deseja continuar?',
          'MOD_SAVE_CAMB_PREGCAT': 'Onde pretende guardar esta modificação do texto da pergunta?',
          'BTN_MOD_SAVE_CAMB_PREGCAT': 'Apenas neste inquérito',
          'BTN_MOD_ACTUA_PREGCAT': 'Actualizar a pergunta no catálogo',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG': 'Carregamento',
        'TEXT_NO_ELEG_ADIC': 'Nenhuma língua adicional escolhida',
        'ERR_MSG_TRADU': 'Tradução ainda não concluída',
        'TEX_IDIO_PRIN': 'Língua principal',
        'TEX_NAM_GRUP': 'Nome do grupo',
        'TEX_TRAD_NAM': 'Introduza a tradução do nome',
        'TEX_NO_TRAD_TEXT': 'Não introduziu o texto de tradução!',
        'TEX_TEX_PREG': 'Texto da pergunta',
        'TEX_TEX_RESP': 'Texto de resposta',
        'TEX__TRA_PREG': 'Introduza a tradução da pergunta',
        'TEX__TRA_RESP': 'Introduza a tradução da resposta',
        'GUAR_TRA_NAM': 'Salvar tradução do nome, por favor aguarde',
        'GUAR_TRA_PRE': 'Salvar tradução de perguntas, por favor aguarde',
        'GUAR_TRA_RES': 'Salvar tradução da opção de resposta, por favor aguarde',
        'INGR_TEX_PRAC_4ALL': 'Prática',
        'INGR_TEX_TRADU_PRAC_4ALL': 'Entrar tradução prática',
        'INGR_TEX_DESCR_4ALL': 'Descrição',
        'INGR_TEX_TRADU_DESCR_4ALL': 'Introduza a tradução da descrição',
        'GUAR_TRADU_PRAC': 'Salvar tradução prática, por favor aguarde...',
        'GUAR_TRADU_DESCR': 'Salvar tradução de descrição, aguarde, por favor...',
      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI': 'Selecione um idioma para exibir as traduções das perguntas',
        'ETI_SIN_TRAD_PRE':'¡O texto de tradução está em falta!',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Adicionar uma faixa de áudio',
          'CHANGE': 'Substituir faixa de áudio'
        },
        'SUBTITULO': 'Você pode associar uma faixa de áudio a esta pergunta por meio de uma das seguintes opções',
        'BOTONES': {
          'RESTART': 'Voltar ao início',
          'NEXT': 'Próximo',
          'BACK': 'Volte',
          'ACEPTAR': 'Aceitar',
          'CANCELAR': 'Cancelar'
        },
        'OPCIONES': {
          'GOOGLE': 'Gere uma narração automática',
          'RECORD': 'Grave uma narração',
          'ARCHIVO': 'Faça upload de um arquivo mp3',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'Você pode editar o texto para gerar narração automática',
            'INPUT': 'Texto da pergunta',
            'INPUT_TT': 'Escreva o texto da pergunta',
            'NOTA': 'NOTA: Modificar este texto não modificará o texto da pergunta na pesquisa'
          },
          'RECORD': {
            'TITULO': 'Clique no botão Gravar para começar a gravar áudio do microfone',
            'NOTA': 'NOTA: Você pode precisar conceder permissão para usar o microfone do navegador',
            'START': 'Comece a gravar',
            'STOP': 'Gravando áudio, clique no botão para interromper a gravação'
          },
          'ARCHIVO': {
            'INPUT': 'Clique aqui ou arraste o arquivo de áudio para esta área para carregá-lo',
            'NOTA': 'NOTA: Apenas o formato MP3 é compatível'
          },
          'PREVIEW': {
            'GENERANDO': 'O áudio está sendo gerado, por favor, aguarde um momento',
            'TITULO': 'Abaixo você pode ouvir o áudio carregado',
            'NOTA_1': 'Se você deseja salvar esta faixa de áudio para a pergunta, clique no botão OK',
            'NOTA_2': 'Se você deseja alterar o áudio, clique no botão Voltar',
            'NOTA_3': 'Se você deseja alterar o tipo de áudio carregado, clique no botão Voltar ao início'
          }
        },
        'MODALES': {
          'DESCARTAR': 'Tem certeza de que deseja voltar à etapa anterior? \n\n A faixa atual será descartada',
          'ARCHIVO_MAL': 'O arquivo enviado não é uma faixa de áudio',
          'GUARDANDO': 'Salvando faixa de áudio para pergunta, aguarde um momento',
          'BORRAR': 'Tem certeza de que deseja excluir a faixa de áudio associada a esta pergunta?',
          'CONFIRMAR_BORRAR': 'Para confirmar, insira o código em vermelho na caixa de texto: \n\n',
          'BORRADO_OK': 'A faixa de áudio da pergunta foi excluída corretamente',
          'CODIGO_MAL': 'O código inserido não corresponde ao indicado em vermelho',
          'AGREGANDO_PREGUNTAS': 'As perguntas selecionadas estão sendo adicionadas à seção, por favor, aguarde um momento'
        },
        'PREVIOS': {
          'TITULO': 'Faixa de áudio associada',
          'SIN_AUDIO': 'Não há trilha de áudio associada',
          'SIN_AUDIO_FORALL': 'Sem faixa de áudio',
          'ADD_AUDIO': 'Adicionar uma faixa de áudio',
          'CON_AUDIO': 'Esta pergunta tem uma trilha de áudio',
          'PLAY': 'Tocar áudio',
          'CHANGE': 'Substitua o áudio',
          'DELETE': 'Apagar áudio',
          'AUDIO_STATEMENT_1': 'Faixa de áudio da declaração 1',
          'AUDIO_STATEMENT_2': 'Faixa de áudio da declaração 2',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Seção especial',
        'SUBTITULO_1': 'Este grupo de perguntas pode ser estabelecido como uma seção especial, as perguntas deste grupo serão mostradas apenas para colaboradores que possuam a mesma senha',
        'SUBTITULO_2': 'NOTA: É necessário que pelo menos um colaborador esteja associado a esta seção especial na etapa de upload de colaborador',
        'TIPOS': {
          'NORMAL': 'Seção normal',
          'ESPECIAL': 'Seção especial'
        },
        'CAMPO': {
          'TITULO': 'Chave de seção',
          'TOOLTIP': 'Escreva a chave desta seção',
          'HINT': 'Sem espaços',
          'ACEPTAR': 'Aceitar'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'Se você desabilitar as seções especiais, os grupos de perguntas atualmente marcados como seções especiais serão convertidos em grupos de perguntas normais, esta mudança se aplicará a todas as seções de perguntas. \n\n Tem certeza que deseja continuar?',
          'DISABLE_OK': 'Todas as seções especiais encontradas foram convertidas em grupos de perguntas normais',
          'SIN_CLAVE': 'Para salvar a seção especial, você precisa inserir uma chave para a seção'
        }
      }
    },
  }
};
